import {AppSettings} from '../constants';
import ManageInsurancePolicies from './Containers/manage-insurance-policies';

export default [
  {
    path: '/insurance-policies',
    component: ManageInsurancePolicies,
    private: true,
    portal: ['Builder'],
    menu: {
      name: 'Insurance policies',
      group: 'Admin',
      order: 2,
      subGroup: 'Other',
      icons: 'icon-insurance-policies-ic',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/Insurance/routes.js